import MuiMenu from "@mui/material/Menu";
import type { MenuProps as MuiMenuProps } from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import type { MenuItemProps as MuiMenuItemProps } from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

export type MenuProps = Omit<MuiMenuProps, "open">;

export type MenuItemProps = MuiMenuItemProps;

export function MenuItem({ onClick, children }: MenuItemProps) {
  return <MuiMenuItem onClick={onClick}>{children} </MuiMenuItem>;
}

function MenuBase({ anchorEl, onClose, children }: MenuProps) {
  return (
    <MuiMenu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose}>
      <MenuList>{children}</MenuList>
    </MuiMenu>
  );
}

type MenuComponent = typeof MenuBase & {
  Item: typeof MenuItem;
};

export const Menu = MenuBase as MenuComponent;
Menu.Item = MenuItem;
